import {
  TemplateForm,
  TemplateFormProps,
} from "./ui/save-notification-template-form/template-form";
import { PropertyProvider } from "./model/property-provider/property-provider";
import { InitialValuesProvider } from "./model/initial-values-provider/initial-values-provider";
import { InitialValues } from "./model/initial-values-provider/initial-values-types";
import { Code } from "./api/get-notification-template-properties-by-code/get-notification-template-properties-by-code";
import { PropertyTree } from "./ui/save-notification-template-form/property-tree";
import { NotificationForm } from "../../shared/notification-form";

export function SaveNotificationTemplateForm({
  afterSubmit,
  partOf,
  forDynamicProcess,
  initialValues,
  code,
  templateId,
  ...formProps
}: Omit<TemplateFormProps, "params" | "initialValues"> & {
  afterSubmit?: () => void;
  initialValues?: InitialValues;
  code?: Code;
  templateId?: string;
}) {
  return (
    <NotificationForm.Grid
      propertyTree={<PropertyTree code={code} templateId={templateId} />}
      form={
        <PropertyProvider templateId={templateId} code={code}>
          <InitialValuesProvider id={templateId} initialValues={initialValues}>
            <TemplateForm
              {...formProps}
              id={templateId}
              afterSubmit={afterSubmit}
              partOf={partOf}
              forDynamicProcess={forDynamicProcess}
              propertyTree={
                <PropertyTree code={code} templateId={templateId} />
              }
            />
          </InitialValuesProvider>
        </PropertyProvider>
      }
    />
  );
}
